import React from 'react';
import {useHistory, useQueryParamsCallback} from '@aboutyou/router';
import {lazy} from '@aboutyou/lazy-imports';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';

const SubscribeToWhatsappNewsletterLazy = lazy(() =>
  import('./SubscribeToWhatsappNewsletter.eager').then(mod => ({
    default: mod.SubscribeToWhatsappNewsletter,
  })),
);

export const SubscribeToWhatsappNewsletter = () => {
  const {whatsappUUIDToken, countryCode} = useWhatsappParams();
  const {isAuthenticated, isUserDataLoading} = useIsAuthenticated();

  if (!whatsappUUIDToken || (!isAuthenticated && isUserDataLoading)) {
    return null;
  }

  return (
    <SubscribeToWhatsappNewsletterLazy
      whatsappUUIDToken={whatsappUUIDToken}
      countryCode={countryCode || ''}
    />
  );
};

export const UUID_QUERY_PARAM_KEY = 'e_waChannelUser';
export const COUNTRY_CODE_QUERY_PARAM_KEY = 'countryCode';

export const useWhatsappParams = () => {
  const getQueryParams = useQueryParamsCallback();
  const newSearch = new URLSearchParams(getQueryParams());
  const whatsappUUIDToken = newSearch.get(UUID_QUERY_PARAM_KEY);
  const countryCode = newSearch.get(COUNTRY_CODE_QUERY_PARAM_KEY);
  const {location, replace} = useHistory();

  const removeWhatsappQueryParams = () => {
    const searchparams = new URLSearchParams(getQueryParams());
    searchparams.delete(UUID_QUERY_PARAM_KEY);
    searchparams.delete(COUNTRY_CODE_QUERY_PARAM_KEY);
    replace({
      ...location,
      search: searchparams.toString(),
    });
  };

  return {
    whatsappUUIDToken,
    countryCode,
    removeWhatsappQueryParams,
  };
};
